// extracted by mini-css-extract-plugin
module.exports = {"container":"Burger_container__4tJ4U","line":"Burger_line__2qE0D","openTop":"Burger_openTop__2hCF8","openMiddle":"Burger_openMiddle__2Cg7K","openBottom":"Burger_openBottom__1YoNa"};